import React from "react";
import zipImageForPayments from "@irati-web/payments/src/images/zip-payments.svg";
import zipDetailsForPayments from "@irati-web/payments/src/images/zip-circle-alert.svg";
import { FormattedMessage } from "@irati/utils/lang";
import Flex from "@irati/ui/src/Flex";
import { Label } from "@irati/ui/src/Typography";
import ZipReadMoreAndModal from "@irati-web/payments/src/components/ZipModal/ZipReadMoreAndModal";
import { PaymentProvider } from "@irati/types";
import { Radio, CustomNodeRenderer } from "@irati/ui/src/FormItem";
import withBasket from "@irati/checkout/utils/basket/withBasket";
import { ZipImage, ZipDetail, HeaderWrapper } from "./styled";
var PayByZip = function (props) {
    var isZipSelected = props.isZipSelected, onSelectZip = props.onSelectZip;
    var discountBeforeZip = props.basket.breakdown.total.discountPercentage;
    var discountAfterZip = props.basket.breakdown.total.discountPercentageAfterServiceCharge;
    var zipOptions = [
        {
            customNode: (React.createElement(Flex, { direction: "column" },
                React.createElement(Flex, { justifyContent: "space-between", alignItems: "center" },
                    React.createElement(ZipImage, { src: zipImageForPayments }),
                    React.createElement(ZipReadMoreAndModal, null)))),
            value: PaymentProvider.Zip,
            whiteSpace: "wrap"
        }
    ];
    return (React.createElement(HeaderWrapper, { selected: isZipSelected },
        React.createElement(Radio, { rowRenderer: CustomNodeRenderer, name: "paymentMethodRadio", value: isZipSelected && PaymentProvider.Zip, options: zipOptions, onChange: function () { return onSelectZip(PaymentProvider.Zip); } }),
        isZipSelected && (React.createElement(Flex, { alignItems: "center", marginTop: 1, paddingBottom: 1, marginLeft: "48px" },
            React.createElement(ZipDetail, { src: zipDetailsForPayments }),
            React.createElement(Label, null,
                React.createElement(FormattedMessage, { id: "platform.wallet.components.payByWallet.zip.details", values: {
                        discountBeforeZip: discountBeforeZip,
                        discountAfterZip: discountAfterZip
                    } }))))));
};
export default withBasket(PayByZip);
